import React, { useState, useEffect, useRef } from 'react';
import PropTypes from "prop-types";

import logo_central from "~/assets/images/3ia_demos_logo_central_light.png";
import placeholderLogo from "~/assets/images/placeholder_logo.png";


const MENUS = {
    DEMOS: 0,
    CHAIRS: 1,
    RESEARCH_AXES: 2,
};

const INTERVAL_DURATION = 8000;  // ms
const RESPONSIVE_BREAKPOINT = 991;  // pt

const IndexApp = (props) => {
    const [hoveredMenu, setHoveredMenu] = useState(MENUS.DEMOS);
    const [responsiveMode, setResponsiveMode] = useState(window.innerWidth <= RESPONSIVE_BREAKPOINT);

    const menuToggleIntervalRef = useRef();

    useEffect(() => {
        menuToggleIntervalRef.current = setInterval(handleToggleMenu, INTERVAL_DURATION);
        $("#content").on("mousemove", handlePointerMove);
        $("#content").on("click", handlePointerClick);

        $(window).on("resize", () => { setResponsiveMode(window.innerWidth <= RESPONSIVE_BREAKPOINT); });
    }, []);

    useEffect(() => {
        if(menuToggleIntervalRef.current) {
            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = setInterval(handleToggleMenu, INTERVAL_DURATION);
        }
    }, [hoveredMenu]);

    const shuffleArray = (arr) => {
        return [...arr].sort(() => 0.5 - Math.random());
    };

    const handleToggleMenu = () => {
        $("#menu").removeClass("show");
        setTimeout(() => { $("#menu").addClass("show"); }, 500);
        setHoveredMenu((hoveredMenu + 1) % Object.keys(MENUS).length);
    };

    const getMenusRadiuses = (event) => {
        const [demosOrbitRing, chairsOrbitRing, researchAxesOrbitRing] = [$("#DEMOS-orbit")[0], $("#CHAIRS-orbit")[0], $("#RESEARCH_AXES-orbit")[0]];
        const demosRadius = demosOrbitRing.offsetWidth / 2;
        const chairsRadius = chairsOrbitRing.offsetWidth / 2;
        const researchAxesRadius = researchAxesOrbitRing.offsetWidth / 2;

        const boundingClientRect = demosOrbitRing.getBoundingClientRect();
        const centerPosition = [boundingClientRect.x + boundingClientRect.width / 2, boundingClientRect.y + boundingClientRect.height / 2];
        const distanceFromCenter = Math.sqrt((centerPosition[0] - event.clientX)**2 + (centerPosition[1] - event.clientY)**2);

        return [distanceFromCenter, demosRadius, chairsRadius, researchAxesRadius];
    };

    const handlePointerMove = (event) => {
        const [distanceFromCenter, demosRadius, chairsRadius, researchAxesRadius] = getMenusRadiuses(event);

        if(distanceFromCenter <= researchAxesRadius) {
            event.target.style.cursor = "pointer";
            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.RESEARCH_AXES);
            return;
        } else if(distanceFromCenter <= chairsRadius) {
            event.target.style.cursor = "pointer";
            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.CHAIRS);
            return;
        } else if(distanceFromCenter <= demosRadius) {
            event.target.style.cursor = "pointer";
            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.DEMOS);
            return;
        } else {
            if(!menuToggleIntervalRef.current)
                menuToggleIntervalRef.current = setInterval(handleToggleMenu, INTERVAL_DURATION);
        }
    };

    const handlePointerClick = (event) => {
        const [distanceFromCenter, demosRadius, chairsRadius, researchAxesRadius] = getMenusRadiuses(event);

        $("#RESEARCH_AXES-orbit").css("background", "transparent");
        $("#CHAIRS-orbit").css("background", "transparent");
        $("#DEMOS-orbit").css("background", "transparent");

        $("#RESEARCH_AXES-orbit").css("--duration", "20s");
        $("#CHAIRS-orbit").css("--duration", "20s");
        $("#DEMOS-orbit").css("--duration", "20s");
        if(distanceFromCenter <= researchAxesRadius) {
            $("#content").off("mousemove");

            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.RESEARCH_AXES);

            $("#RESEARCH_AXES-orbit").css("background", "rgba(255, 255, 255, 0.25)");

            $("#CHAIRS-orbit").css("--duration", "60s");
            $("#DEMOS-orbit").css("--duration", "60s");

            $("#circles-helper-text").hide();
            return;
        } else if(distanceFromCenter <= chairsRadius) {
            $("#content").off("mousemove");

            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.CHAIRS);

            $("#CHAIRS-orbit").css("background", "rgba(255, 255, 255, 0.25)");

            $("#RESEARCH_AXES-orbit").css("--duration", "60s");
            $("#DEMOS-orbit").css("--duration", "60s");

            $("#circles-helper-text").hide();
            return;
        } else if(distanceFromCenter <= demosRadius) {
            $("#content").off("mousemove");
            
            clearInterval(menuToggleIntervalRef.current);
            menuToggleIntervalRef.current = null;
            setHoveredMenu(MENUS.DEMOS);

            $("#DEMOS-orbit").css("background", "rgba(255, 255, 255, 0.25)");

            $("#RESEARCH_AXES-orbit").css("--duration", "60s");
            $("#CHAIRS-orbit").css("--duration", "60s");

            $("#circles-helper-text").hide();
            return;
        } else {
            $("#content").on("mousemove", handlePointerMove);

            if(!menuToggleIntervalRef.current)
                menuToggleIntervalRef.current = setInterval(handleToggleMenu, INTERVAL_DURATION);

            $("#circles-helper-text").show();
        }
    };

    return responsiveMode ? <div className = 'px-2 py-3'>
        <div className = "position-relative mx-auto" style = {{ width: "90%", aspectRatio: 1 }}>
            <div className = 'position-absolute top-50 start-50 translate-middle'>
                <img src = { logo_central } className = "w-100" alt="..." />
            </div>
            {
                Object.keys(MENUS).map((menu, i) => {
                    const menus = [props.demos, props.chairs, props.researchAxes];
                    let color = `rgba(255, 255, 255, ${hoveredMenu == i ? "1" : "0.5"})`;

                    return <div
                        key = { i }
                        id = { `${menu}-orbit` }
                        className = "orbit-container rounded-circle shadow position-absolute top-0 bottom-0 start-0 end-0"
                        style = {{
                            "--duration": "20s",
                            "--direction": i % 2 == 0 ? "normal" : "reverse",
                            margin: i * 30,
                        }}
                    >
                        <span
                            className = "orbit"
                            style = {{
                                "--number": menus[i].length,
                                "--color": color,
                                "--distance": `${360 / (menus[i].length * 5) }deg`,
                            }}
                        >
                        </span>
                    </div>;
                })
            }
        </div>
        <h2 className = "text-center text-dark mt-3 mb-2">Demos</h2>
        <ul className = "list-unstyled">
            {
                props.demos.slice(0, 5).map((demo, i) => {
                    return i < 4 ? <li
                        key = { demo.title }
                        className = "responsive-menu-item rounded text-primary d-flex m-2"
                    >
                        <img src = { demo.logo ? demo.logo : placeholderLogo } height = { 200 } />
                        <div className = 'flex-grow-1 p-3 d-flex flex-column'>
                            <a href = { demo.url } className = 'stretched-link fw-bold flex-grow-1'>
                                { demo.title }
                                <div className = 'tags-container d-flex flex-wrap fs-6 text-nowrap overflow-hidden'>
                                    {
                                        demo.tags.map((tag, j) => (
                                            <small key = { j } className = 'rounded-pill border border-primary border-1 bg-primary text-light px-2 py-1 me-2 mb-2'>
                                                { tag.label }
                                            </small>
                                        ))
                                    }
                                </div>
                            </a>
                            <small className = 'd-block fs-6'>{ demo.headline }</small>
                        </div>
                    </li> :
                    <li
                        key = "see-more"
                        className = "responsive-menu-item rounded text-primary p-3 m-2"
                    >
                        <a href = { props.demoIndexUrl } className = 'stretched-link'>
                            Explore 3IA demos <i className = "bi bi-chevron-right"></i>
                        </a>
                    </li>;
                })
            }
        </ul>
        <h2 className = "text-center text-dark mt-3 mb-2">Chairs</h2>
        <ul className = "list-unstyled">
            {
                props.chairs.slice(0, 5).map((chair, i) => {
                    return i < 4 ? <li
                        key = { chair.title }
                        className = "responsive-menu-item rounded text-primary d-flex m-2"
                    >
                        <img src = { chair.picture } height = { 200 } />
                        <div className = 'flex-grow-1 p-3 d-flex flex-column'>
                            <a
                                href = { chair.url }
                                className = 'stretched-link fw-bold flex-grow-1 overflow-hidden'
                                style = {{ textOverflow: "ellipsis" }}
                            >
                                { chair.title }
                            </a>
                            <small className='d-block fs-6'>{ chair.chairholder }</small>
                        </div>
                    </li> :
                    <li
                        key = "see-more"
                        className = "responsive-menu-item rounded text-primary p-3 m-2"
                    >
                        <a href = { props.chairIndexUrl } className = 'stretched-link'>
                            Explore 3IA chairs <i className = "bi bi-chevron-right"></i>
                        </a>
                    </li>;
                })
            }
        </ul>
        <h2 className = "text-center text-dark mt-3 mb-2">Research Axes</h2>
        <ul className = "list-unstyled">
            {
                props.researchAxes.slice(0, 5).map((researchAxis, i) => {
                    return i < 4 ? <li
                        key = { researchAxis.title }
                        className = "responsive-menu-item rounded text-primary d-flex m-2"
                    >
                        <img src = { researchAxis.picture } width = { 200 } />
                        <div className = 'flex-grow-1 p-3'>
                            <a href = { researchAxis.url } className = 'stretched-link fw-bold'>{ researchAxis.title }</a>
                        </div>
                    </li> :
                    <li
                        key = "see-more"
                        className = "responsive-menu-item rounded text-primary p-3 m-2"
                    >
                        <a href = { props.researchAxisIndexUrl } className = 'stretched-link'>
                            Explore 3IA research axes <i className = "bi bi-chevron-right"></i>
                        </a>
                    </li>;
                })
            }
        </ul>
    </div> : <>
        <div className = 'overflow-hidden position-absolute top-0 bottom-0 start-0 end-0'>
            <div className = "position-absolute top-0 end-0 m-4 text-end text-dark">
                <h2>
                    { hoveredMenu == MENUS.DEMOS ? "Demos" : null }
                    { hoveredMenu == MENUS.CHAIRS ? "Chairs" : null }
                    { hoveredMenu == MENUS.RESEARCH_AXES ? "Research Axes" : null }
                </h2>
                <small id = "circles-helper-text" className='text-muted'>Click on rings to freeze display</small>
            </div>
            <div className = 'position-absolute top-0 bottom-0 start-0 end-0'>
                <div id = "spinning-logo" className = 'translate-middle'>
                    <div className = 'position-absolute top-0 bottom-0 start-0 end-0'>
                        <img src = { logo_central } className = 'w-100 h-100' alt="..." />
                    </div>
                    {
                        Object.keys(MENUS).map((menu, i) => {
                            const menus = [props.demos, props.chairs, props.researchAxes];
                            let color = `rgba(255, 255, 255, ${hoveredMenu == i ? "1" : "0.5"})`;

                            return <div
                                key = { i }
                                id = { `${menu}-orbit` }
                                className = "orbit-container rounded-circle shadow position-absolute top-0 bottom-0 start-0 end-0"
                                style = {{
                                    "--duration": "20s",
                                    "--direction": i % 2 == 0 ? "normal" : "reverse",
                                    margin: i * 30,
                                }}
                            >
                                <span
                                    className = "orbit"
                                    style = {{
                                        "--number": menus[i].length,
                                        "--color": color,
                                        "--distance": `${360 / (menus[i].length * 5) }deg`,
                                    }}
                                >
                                </span>
                            </div>;
                        })
                    }
                </div>
            </div>
            <div className = 'position-absolute top-0 bottom-0 start-0 end-0'>
                <ul className = "position-absolute top-0 bottom-0 start-0 end-0 list-unstyled m-0 show" id = "menu">
                    <div className = "menu-side-halo position-absolute top-50 start-0 translate-middle"></div>
                    {
                        hoveredMenu == MENUS.DEMOS ? <>
                            {
                                shuffleArray(props.demos).slice(0, 5).map((demo, i) => {
                                    return i < 4 ? <li
                                        key = { demo.title }
                                        className = "menu-item rounded text-primary d-flex"
                                    >
                                        <img src = { demo.logo ? demo.logo : placeholderLogo } />
                                        <div className = 'flex-grow-1 p-3 d-flex flex-column'>
                                            <a href = { demo.url } className = 'stretched-link fw-bold flex-grow-1'>
                                                { demo.title }
                                                <div className = 'tags-container d-flex flex-wrap fs-6 text-nowrap overflow-hidden'>
                                                    {
                                                        demo.tags.map((tag, j) => (
                                                            <small key = { j } className = 'rounded-pill border border-primary border-1 bg-primary text-light px-2 py-1 me-2 mb-2'>
                                                                { tag.label }
                                                            </small>
                                                        ))
                                                    }
                                                </div>
                                            </a>
                                            <small className = 'd-block fs-6'>{ demo.headline }</small>
                                        </div>
                                    </li> :
                                    <li
                                        key = "see-more"
                                        className = "menu-item rounded text-primary p-3"
                                    >
                                        <a href = { props.demoIndexUrl } className = 'stretched-link'>
                                            Explore 3IA demos <i className = "bi bi-chevron-right"></i>
                                        </a>
                                    </li>;
                                })
                            }
                        </> :
                        null
                    }
                    {
                        hoveredMenu == MENUS.CHAIRS ? <>
                            {
                                shuffleArray(props.chairs).slice(0, 5).map((chair, i) => {
                                    return i < 4 ? <li
                                        key = { chair.title }
                                        className = "menu-item rounded text-primary d-flex"
                                    >
                                        <img src = { chair.picture } />
                                        <div className = 'flex-grow-1 p-3 d-flex flex-column'>
                                            <a
                                                href = { chair.url }
                                                className = 'stretched-link fw-bold flex-grow-1 overflow-hidden'
                                                style = {{ textOverflow: "ellipsis" }}
                                            >
                                                { chair.title }
                                            </a>
                                            <small className='d-block fs-6'>{ chair.chairholder }</small>
                                        </div>
                                    </li> :
                                    <li
                                        key = "see-more"
                                        className = "menu-item rounded text-primary p-3"
                                    >
                                        <a href = { props.chairIndexUrl } className = 'stretched-link'>
                                            Explore 3IA chairs <i className = "bi bi-chevron-right"></i>
                                        </a>
                                    </li>;
                                })
                            }
                        </> :
                        null
                    }
                    {
                        hoveredMenu == MENUS.RESEARCH_AXES ? <>
                            {
                                props.researchAxes.slice(0, 5).map((researchAxis, i) => {
                                    return i < 4 ? <li
                                        key = { researchAxis.title }
                                        className = "menu-item rounded text-primary d-flex"
                                    >
                                        <img src = { researchAxis.picture } />
                                        <div className = 'flex-grow-1 p-3'>
                                            <a href = { researchAxis.url } className = 'stretched-link fw-bold'>{ researchAxis.title }</a>
                                        </div>
                                    </li> :
                                    <li
                                        key = "see-more"
                                        className = "menu-item rounded text-primary p-3"
                                    >
                                        <a href = { props.researchAxisIndexUrl } className = 'stretched-link'>
                                            Explore 3IA research axes <i className = "bi bi-chevron-right"></i>
                                        </a>
                                    </li>;
                                })
                            }
                        </> :
                        null
                    }
                </ul>
            </div>
        </div>
    </>;
};

IndexApp.propTypes = {
    demoIndexUrl: PropTypes.string,
    chairIndexUrl: PropTypes.string,
    researchAxisIndexUrl: PropTypes.string,
    demos: PropTypes.arrayOf(PropTypes.object),
    chairs: PropTypes.arrayOf(PropTypes.object),
    researchAxes: PropTypes.arrayOf(PropTypes.object),
};

export default IndexApp;
